import { render, staticRenderFns } from "./LatestPublications.vue?vue&type=template&id=b818e866&scoped=true&"
import script from "./LatestPublications.vue?vue&type=script&lang=js&"
export * from "./LatestPublications.vue?vue&type=script&lang=js&"
import style0 from "./LatestPublications.vue?vue&type=style&index=0&id=b818e866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b818e866",
  null
  
)

export default component.exports